import React from 'react';
import { createPortal } from 'react-dom';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  confirmVariant?: 'danger' | 'primary';
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Delete',
  confirmVariant = 'danger'
}) => {
  console.log('ConfirmationDialog rendering with isOpen:', isOpen);
  console.log('onConfirm prop:', onConfirm);
  
  if (!isOpen) {
    return null;
  }

  const dialogContent = (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[99999]" 
      style={{ pointerEvents: 'auto' }}
      onClick={(e) => {
        console.log('Backdrop clicked');
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div 
        className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 rounded-lg shadow-xl p-8 w-full max-w-sm relative"
        style={{ pointerEvents: 'auto' }}
        onClick={(e) => {
          console.log('Dialog content clicked');
          e.stopPropagation();
        }}
      >
        <h3 className="text-lg font-semibold mb-4">{title}</h3>
        <p className="mb-6 text-slate-600 dark:text-slate-400">{message}</p>
        <div className="flex justify-end space-x-4">
          <div
            onClick={(e) => {
              console.log('Cancel div clicked in ConfirmationDialog');
              e.stopPropagation();
              onClose();
            }}
            className="px-4 py-2 border border-slate-300 dark:border-slate-600 bg-transparent hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-lg font-medium transition-colors cursor-pointer select-none"
            style={{ pointerEvents: 'auto' }}
          >
            Cancel
          </div>
          <div
            onMouseEnter={() => console.log('Delete div mouse enter')}
            onMouseDown={() => console.log('Delete div mouse down')}
            onMouseUp={() => console.log('Delete div mouse up')}
            onClick={(e) => {
              console.log('Delete div clicked in ConfirmationDialog');
              console.log('Event:', e);
              console.log('onConfirm function:', onConfirm);
              console.log('Calling onConfirm...');
              e.preventDefault();
              e.stopPropagation();
              try {
                onConfirm();
                console.log('onConfirm called successfully');
              } catch (error) {
                console.error('Error calling onConfirm:', error);
              }
            }}
            className={`px-4 py-2 rounded-lg font-medium transition-colors cursor-pointer select-none ${
              confirmVariant === 'danger' 
                ? 'bg-red-500 text-white hover:bg-red-600' 
                : 'bg-blue-500 text-white hover:bg-blue-600'
            }`}
            style={{ pointerEvents: 'auto' }}
          >
            {confirmText}
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(dialogContent, document.body);
};

export default ConfirmationDialog;
